import { render, staticRenderFns } from "./AboutWorld.vue?vue&type=template&id=6c420e18&scoped=true"
import script from "./AboutWorld.vue?vue&type=script&lang=js"
export * from "./AboutWorld.vue?vue&type=script&lang=js"
import style0 from "./AboutWorld.vue?vue&type=style&index=0&id=6c420e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c420e18",
  null
  
)

export default component.exports